import { Typography } from "@mui/material";
import { Grid, List, ListItemButton } from "@mui/material";
import { Header } from "gf-ui-components-mui-lib";
import {
  Moon,
  Notification,
  Contact,
  AccountSettings,
  Sun,
  Logout,
  DownOrgArr,
  DropOrgIcon
} from "@/icons";
import { useAuth } from "@/hooks/auth.hooks";
import { getCookie } from "@/utils";
import Breadcrumb from "./Breadcrumb";
import { getSubdomain } from "@/utils/common";
import { PARTNER_SUB_DOMAIN } from "@/config";
import { SIDEBAR_WIDTH } from "@/layouts/full/sidebar";

const HeaderLayout = ({
  isSmallScreen,
  toggleTheme,
  customTheme,
  isDropdownOpen,
  dropdownItems,
  handleDropdownSelect,
  changeSelectedOrg,
  organizationName
}: any) => {
  const isAdminAccess = getCookie("xsm_admin_access") ?? "";
  const adminAccounts = localStorage.getItem("admin_accounts");
  const isSuperAdminAccounts = adminAccounts ? JSON.parse(adminAccounts) : [];
  const subdomain = getSubdomain();
  const showOrgDropdownAccess = subdomain === PARTNER_SUB_DOMAIN ? true : false;
  const { handleLogout, loggedUser, handleAccountSettings, hasSingleProduct } = useAuth();
  const isSuperAdmin = isSuperAdminAccounts.includes(isAdminAccess);

  const controls_data = [
    {
      id: "theme",
      label: "Theme",
      icon: customTheme === "light" ? <Moon /> : <Sun />,
      handleControl: () => toggleTheme()
    },
    {
      id: "notification",
      label: "Notification",
      icon: <Notification />
    }
  ];

  const menuitems = [
    {
      id: "accsettings",
      label: "Account Settings",
      icon: <AccountSettings />,
      styles: {
        p: "16px"
      },
      handleItem: () => handleAccountSettings()
    },
    {
      id: "logout",
      label: hasSingleProduct ? "Logout" : "Exit",
      icon: <Logout />,
      styles: {
        p: "16px"
      },
      handleItem: () =>
        handleLogout({ redirectToLogoutEndpoint: hasSingleProduct })
    }
  ];

  return (
    <Header
      {...{
        position: "fixed",
        color: "inherit",
        searchBar: false,
        controls: controls_data,
        user: isAdminAccess ? "admin" : loggedUser?.first_name ?? "",
        menuItems: menuitems,
        xsmadmin: true,
        adminIcon: <Contact />,
        children: (
          <>
            <Breadcrumb
              separableicon={true}
              isSmallScreen={isSmallScreen}
              separaterStyles={{
                "& .MuiBreadcrumbs-separator": {
                  margin: 0
                }
              }}
            />
          </>
        ),
        chipChild: (
          <>
            {!isSuperAdmin && showOrgDropdownAccess && (
              <Grid>
                <Grid
                  onClick={changeSelectedOrg}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px",
                    borderRadius: "10px",
                    border: "1px solid #E6E6E6",
                    cursor: "pointer",
                    width: "236px",
                    justifyContent: "space-between"
                  }}
                >
                  <Grid
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px"
                    }}
                  >
                    <DropOrgIcon fill="#242424" />
                    <Typography
                      sx={{
                        color: "black",
                        fontSize: "16px",
                        fontFamily: "Poppins",
                        fontWeight: "400",
                        lineHeight: "24px"
                      }}
                    >
                      {organizationName}
                    </Typography>
                  </Grid>
                  <DownOrgArr fill="#737373" />
                </Grid>
                <Grid
                  sx={{
                    position: "relative"
                  }}
                >
                  {isDropdownOpen && (
                    <Grid
                      className="select-org-dropdown"
                      style={{
                        position: "absolute",
                        top: "0px",
                        right: "0px",
                        display: "flex",
                        padding: "16px 0px",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "8px",
                        borderRadius: "16px",
                        background: "#FFF",
                        boxShadow:
                          "0px -4px 8px 0px rgba(0, 0, 0, 0.05), 0px 4px 8px 0px rgba(0, 0, 0, 0.10)",
                        zIndex: 999,
                        width: "236px"
                      }}
                    >
                      <List
                        component="nav"
                        sx={{
                          padding: "0px !important",
                          width: "100%"
                        }}
                      >
                        {dropdownItems?.map((item: any) => {
                          return (
                            <ListItemButton
                              key={item.id}
                              style={{
                                padding: "8px 16px",
                                display: "flex",
                                alignItems: "center",
                                color: "#0A1629",
                                fontFamily: "Poppins",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "24px"
                              }}
                              onClick={() => handleDropdownSelect(item)}
                            >
                              {item.name}
                            </ListItemButton>
                          );
                        })}
                      </List>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            )}
          </>
        ),
        sx: {
          boxShadow: "none",
          zIndex: "10",
          height: "86px",
          justifyContent: "center",
          marginLeft: `${SIDEBAR_WIDTH}px`,
          width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
          padding: "0px 32px",
          "& .MuiToolbar-root": {
            paddingRight: "0px",
            paddingLeft: "0px"
          },
          "&.MuiButtonBase-root.MuiMenuItem-root": {
            padding: "16px"
          }
        }
      }}
    />
  );
};

export default HeaderLayout;
